module.exports = __webpack_public_path__ + "static/img/support.d08d9f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/support.png
// module id = 14
// module chunks = 0